import { LANG } from '@bm-js/atlascloud-shared'
import {
  PropsWithChildren,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react'
import {
  ALL_TRANSLATIONS,
  getLangFromLs,
  LANG_LS_KEY,
  LangContext,
} from '../contexts/Lang.context'
import { _objectKeys } from '@naturalcycles/js-lib/types'
import { useAuth } from '../utils/hooks'
import { useFetcher } from '../utils/fetcher'

const LangProvider = ({ children }: PropsWithChildren) => {
  const [currentLang, setCurrentLang] = useState<LANG>(LANG.SV_SE)
  const fetcher = useFetcher()
  const { user } = useAuth()

  const translations = useMemo(() => {
    return ALL_TRANSLATIONS[currentLang]
  }, [currentLang])

  const patchLangForUser = useCallback(
    async (lang: LANG) => {
      await fetcher({
        path: 'customer/self/user-information',
        method: 'POST',
        body: { lang },
      })
    },
    [fetcher]
  )

  const changeLang = useCallback(
    (lang: LANG) => {
      setCurrentLang(lang)
      localStorage.setItem(LANG_LS_KEY, lang)
      void patchLangForUser(lang)
    },
    [patchLangForUser]
  )

  useEffect(() => {
    const lsLang = getLangFromLs()
    if (lsLang) {
      // eslint-disable-next-line
      setCurrentLang(lsLang)
    } else if (user?.lang) {
      setCurrentLang(user.lang)
    } else {
      setCurrentLang(LANG.SV_SE)
    }
  }, [user?.lang])

  return (
    <LangContext.Provider
      value={{
        currentLang,
        changeLang,
        translations,
        availableLangs: _objectKeys(ALL_TRANSLATIONS),
      }}
    >
      {children}
    </LangContext.Provider>
  )
}

export default LangProvider
